import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';

export function safeStringify(object: any) {
	try {
		return JSON.stringify(object);
	} catch {
		return '!not-json-representable';
	}
}

export function deepCopy<T>(val: T): T {
	return cloneDeep(val);
}

export function isEmpty(v: object) {
	return Object.keys(v).length === 0;
}

export function asStrings<K extends string, T extends Record<K, any>>(v: T): Record<K, string> {
	const result = {} as Record<K, string>;
	for (const key of Object.keys(v) as K[]) {
		result[key] = `${v[key]}`;
	}
	return result;
}

export function deepEquals<T>(one: T, two: T) {
	return isEqual(one, two);
}

export function cloneArrayOfObjects<T extends object>(theArray: Array<T>): Array<T> {
	return theArray.map((a: object) => ({ ...a }) as T);
}

export function undefinedToNull<T>(input: T | undefined): T | null {
	return input === undefined ? null : input;
}

/**
 * Return the value of something that is either a literal or a generator for a literal.
 */
export function valueOf<T>(t: T | (() => T)): T {
	if (t instanceof Function) return t();
	return t;
}
